module.exports = __webpack_public_path__ + "img/card.ea21cd55.png";